<mat-card class="card-password">
  <div class="font-extrabold text-2xl text-center">
    Existe tarifário com esse trecho.
  </div>
  <div class="flex flex-col justify-around items-center mt-5 -mx-2 gap-4">
    <button mat-flat-button class="btn-tg-cancel w-6/12" (click)="response(false)">
      Cancelar criação
    </button>
    <button mat-flat-button class="btn-tg-white w-6/12" (click)="response(true)">
      Devolver para proposta
    </button>
  </div>
</mat-card>
